export const getTechRoomName = room => room && room.name
export const getTechRoomColor = room => room && room.data?.color